import React, { useState, useEffect, useRef } from "react";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
import SubFooter from "../SubFooter/SubFooter";
import LoginCarousel from "./LoginCarousel"
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { AiFillCheckCircle } from 'react-icons/ai';
import "./Login.css";
import google from "../../Assets/google.png";
import facebook from "../../Assets/facebook.png";

function LoginNew(){
  	const [disable, setDisable] = useState(false);
  	const [loginForm, setLoginForm] = useState(true);
  	const [OTPForm, setOTPForm] = useState(false);
  	const [OTPVerifyForm, setOTPVerifyForm] = useState(false);
  	const [ValidOTPPhone, setValidOTPPhone] = useState(false);
  	const [phoneNumber, setPhoneNumber] = useState("");
  	const [OtpPhoneNumber, setOtpPhoneNumber] = useState("");
  	const [MobileNumberCh, setMobileNumberCh] = useState("");
  	const [password, setPassword] = useState("");
  	const [passwordShown, setPasswordShown] = useState(false);
  	const [passwordEyeShown, setPasswordEyeShown] = useState(false);
  	const [MobileErr, setMobileErr] = useState("");
  	const [OtpButtonName, setOtpButtonName] = useState("Get OTP");
  	const [otpError, setOtpError] = useState("");
  	var [otp1, setotp1] = useState(new Array(6).fill(""));
  	const [seconds, setSeconds] = useState(0);

	const handleLoginSubmit = (e) => {

	}
	const handleMobileChange = (e) => {
		setPhoneNumber(e.target.value);
	    if (e.target.value.charAt(0) < 6) {
	      setMobileErr("Enter a valid mobile number");
	    }
	    if (e.target.value.length != 10) {
	      setMobileErr("Enter a valid mobile number");
	    }
	    if (
	      e.target.value.length == 10 &&
	      e.target.value.charAt(0) >= 6
	    ) {
	      setMobileErr("");
	    }
	    if (e.target.value == "") {
	      setMobileErr("");
	    }
	}
	const handleOTPMobileChange = (e) =>{
		setOtpPhoneNumber(e.target.value)
		if (e.target.value.charAt(0) < 6) {
	      	setMobileErr("Enter a valid mobile number");
	      	setValidOTPPhone(false);
	      	setOtpButtonName("Get OTP");
	    }
	    if (e.target.value.length != 10) {
	      	setMobileErr("Enter a valid mobile number");
	      	setValidOTPPhone(false);
	      	setOtpButtonName("Get OTP");
	    }
	    if (
	      e.target.value.length == 10 &&
	      e.target.value.charAt(0) > 6
	    ) {
	      	setMobileErr("");
	      	setValidOTPPhone(true);
	      	setOtpButtonName("Continue");
	    }
	    if (e.target.value == "") {
	      	setMobileErr("");
	      	setValidOTPPhone(false);
	      	setOtpButtonName("Get OTP");
	    }
	}
	const handleMobileNumberChange =(e)=>{
		setMobileNumberCh(e.target.value)
		if (e.target.value.charAt(0) < 6) {
	      	setMobileErr("Enter a valid mobile number");
	      	setValidOTPPhone(false);
	    }
	    if (e.target.value.length != 10) {
	      	setMobileErr("Enter a valid mobile number");
	      	setValidOTPPhone(false);
	    }
	    if (
	      e.target.value.length == 10 &&
	      e.target.value.charAt(0) > 6
	    ) {
	      	setMobileErr("");
	      	setValidOTPPhone(true);
	    }
	    if (e.target.value == "") {
	      	setMobileErr("");
	      	setValidOTPPhone(false);
	    }
	}
	const handlePasswordChange = (e) => {
		setPassword(e.target.value);
	}
	const handlePasswordShow = () => {
		setPasswordShown(!passwordShown);
		setPasswordEyeShown(!passwordEyeShown)
	}
	const handleLoginOTP = ()=>{
		setLoginForm(false);
		// setOTPForm(true);
		setOTPVerifyForm(true)
	}
	const handleOTPSubmit = () =>{

	}
	const handleOTOVerifySubmit = () =>{

	}
	const otpClear = () => {
	    setotp1([...otp1.map((d) => "")]);
	};
	const handleOTPEnter = (element, index) => {
	    if (isNaN(element.value)) return false;
	    setotp1([...otp1.map((d, idx) => (idx === index ? element.value : d))]);
	    var input = document.getElementById(`id${index}`);
	    input.onkeydown = function(e) {
	      var key = e.keyCode || e.charCode;
	      if (key == 8 || key == 46) {
	        const next = e.target.tabIndex;
	        input.previousSibling.focus();
	      }
	    };
	    if (element.nextSibling) {
	      element.nextSibling.focus();
	    }
	};
	return(
		<>
      		<NewHeader />
      		<div className="loginMainHeading">
		        <h1>Welcome To Redcliffe Labs! </h1>
		    </div>
      		<div className="loginNewContent">
      			<div className="loginNewFormDiv">
      				<div className="CarouselDivOfLogin">
      					<LoginCarousel />
      				</div>
      				<form
			            className={loginForm ? "modal-form login-form " : "hide"}
			            onSubmit={handleLoginSubmit}
			        >
			            <h2>Login</h2>
			            <p className="Loginpara"> Enter Your Mobile Number</p>
			            <div className="InputAddOn">
				            <span className="InputAddOn-item">+91</span>
				            <input
				            	type="number"
				              	onChange={handleMobileChange}
				              	value={phoneNumber}
				              	placeholder="Enter Mobile Number"
				              	required
				              	className="InputAddOn-field"
				            ></input>
				            <span
			                  style={{
			                    color: "red",
			                    marginBottom: "10px",
			                    position: "absolute",
			                    fontSize: "13px",
			                    bottom: "-20px",
			                  }}
			                >
			                  {MobileErr}
			                </span>
				        </div>
			            <p className="Loginpara"> Enter Your Password</p>
			            <div className="PasswordInputAdd">
				            <input
				            	type={passwordShown ? "text" : "password"}
				              	onChange={handlePasswordChange}
				              	value={password}
				              	placeholder="Enter Password"
				              	required
				              	className="password-field"

				            ></input>
				            {passwordEyeShown ?
				            <FaEye className="passwordEyes" onClick={handlePasswordShow} />
				            :
				            <FaEyeSlash className="passwordEyes" onClick={handlePasswordShow} />
				        	}
				        </div>
			            <p className="forgotPasswordd">Forgot Password?</p>
			            {/*<span value={messageTel} className="errors">
			              {messageTel}
			            </span>*/}

			            <button
			              disabled={disable}
			              className={disable ? "Login__submit disable " : "Login__submit"}
			            >
			              <span className="btn">Continue</span>
			            </button>
			            <p className="OrString">Or</p>
			            <button type="button" className="loginWOTP" onClick={handleLoginOTP}>
			              Login with OTP
			            </button>
			            <p className="OrString">Or</p>
			            <div className="socialLoginButton">
			            	<button type="button"><img src={google} alt="google" height="30" width="30" /></button>
			            	<button type="button"><img src={facebook} alt="facebook" height="30" width="30" /></button>
			            </div>
			        </form>
			        <form className={OTPForm ? "modal-form login-form OTPForm" : "hide"} onSubmit={handleOTPSubmit}>
			        	<p className="Loginpara"> Enter Your Mobile Number</p>
			            <div className="InputAddOn">
				            <span className="InputAddOn-item">+91</span>
				            <input
				            	type="number"
				              	onChange={handleOTPMobileChange}
				              	value={OtpPhoneNumber}
				              	placeholder="Enter Mobile Number"
				              	required
				              	className="InputAddOn-field"
				              	style={{fontWeight:"500"}}
				            ></input>
				            { ValidOTPPhone ? <AiFillCheckCircle className="rightMobileN" />: null}
				            <span
			                  style={{
			                    color: "red",
			                    marginBottom: "10px",
			                    position: "absolute",
			                    fontSize: "13px",
			                    bottom: "-20px",
			                  }}
			                >
			                  {MobileErr}
			                </span>
				        </div>
				        <button
			              disabled={disable}
			              className={disable ? "Login__submit disable " : "Login__submit"}
			            >
			              <span className="btn">{OtpButtonName}</span>
			            </button>
			        </form>
			        <form
			            onSubmit={handleOTOVerifySubmit}
			            autoComplete="off"
			            className={OTPVerifyForm ? "modal-form login-form show OTPVerifyForm" : " hide"}
			        >
			            <h2>Verify</h2>
			            <p className="OtpVerifypara">Enter the 6-digit OTP sent to</p>
			            <p className="OtpVerifypara">+91 7020764458</p>
			            <p className="Loginpara2" style={{marginTop:"20px", marginBottom:"20px"}}>OTP</p>
			            <div className="otpFieldDiv">
			              {otp1.map((data, index) => (
			                <input
			                  className="otpField"
			                  placeholder="-"
			                  type="text"
			                  name="otp"
			                  id={`id${index}`}
			                  required
			                  maxLength="1"
			                  key={index}
			                  value={data}
			                  tabIndex={`${index}`}
			                  onChange={(e) => handleOTPEnter(e.target, index)}
			                  onFocus={(e) => e.target.select()}
			                />
			              ))}
			            </div>
			            <div className="OtpResendDivv">
			                <p className="codeResendd">Did not receive the code?</p>
			                <p className="resendOtpp">
			                  Resend
			                </p>
			                <p className="OTPTimerr">00:30</p>
			            </div>
			            <p className="Loginpara"> Enter Your Mobile Number</p>
			            <div className="InputAddOn">
				            <span className="InputAddOn-item">+91</span>
				            <input
				            	type="number"
				              	onChange={handleMobileNumberChange}
				              	value={MobileNumberCh}
				              	placeholder="Enter Mobile Number"
				              	required
				              	className="InputAddOn-field"
				              	style={{fontWeight:"500"}}
				            ></input>
				            { ValidOTPPhone ? <span className="mobileNumberChange">Change</span>: null}
				            <span
			                  style={{
			                    color: "red",
			                    marginBottom: "10px",
			                    position: "absolute",
			                    fontSize: "13px",
			                    bottom: "-20px",
			                  }}
			                >
			                  {MobileErr}
			                </span>
				        </div>
			            <button type="submit" className="OTPVerify_submit">
			              <span className="btn">Continue</span>
			            </button>
			        </form>
      			</div>
      		</div>
      		<Footer />
		</>
	)
}

export default {
  component: LoginNew,
};
